import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import BackIcon from '../assets/img/back-btn.svg';
import OTPInput from './otpinput';
import CountdownTimer from './otptimer';

function ForgetOtptDan() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(""); // مقدار OTP کاربر
  const [loading, setLoading] = useState(false); // وضعیت لودینگ

  const handleSubmit = async () => {
    const mobile = localStorage.getItem("mobile"); // شماره موبایل ذخیره شده
    if (!mobile) {
      alert("شماره موبایل یافت نشد!");
      return;
    }

  
    console.log(mobile);

    setLoading(true);


    try {
      const response = await fetch('https://app.doneapp.ir/backend/forget.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          mobile: mobile,
          otp: otp,
          step: 2

         }),
      });

      if (!response.ok) throw new Error('خطا در دریافت پاسخ از سرور');

      const result = await response.json();


      if (result.status === "success") {
        localStorage.setItem("tokenchangepass", result.token);
        navigate("/new-pass");
    } else {
        console.log(result);
    }
    
    } catch (error) {
      console.error("خطا در ارسال درخواست:", error);
      alert("مشکلی پیش آمده، دوباره تلاش کنید!");
    }

    setLoading(false);
  };

  return (
    <>
      <div className="start-bdy">
        <button className="back-btn-1" onClick={() => navigate("/forget")}>
          <img src={BackIcon} alt='back' />
        </button>

        <div className="logomotion tw-200">
          <div className="start-logo">
            <img src={DanLogo} alt="Dan Logo" />
            <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
          </div>
        </div>

        <div className="loginbtns-2">
          <div className="btndiv-1">
            <div className='forget-title-1'>جهت بازیابی رمز عبور شماره خود را وارد نمایید</div>
            
            <OTPInput value={otp} onChange={setOtp} />
            <CountdownTimer initialTime={120} />

            <button 
              type="submit" 
              className="loginbtn-1" 
              onClick={handleSubmit}
              disabled={loading || otp.length < 6} // دکمه زمانی فعال شود که کد کامل وارد شود
            >
              {loading ? "در حال بررسی..." : "بازیابی رمز عبور"}
            </button>

          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetOtptDan;
